(function (angular) {
  "use strict";

  angular
    .module("app")
    .service("BusinessInterestsApi", businessInterestsResource);

  businessInterestsResource.$inject = ["settings", "$resource"];

  function businessInterestsResource(settings, $resource) {
    /**
     * Adds extra methods and values. Expectes "this" to be bound to an item object
     * @return {this}
     */
    function transform() {
      return this;
    }

    // Create the resource
    var resource = $resource(
      settings.apiBase + "/business-interests/",
      {},
      {
        post: {
          method: "GET",
          responseType: "json",
          params: {
            id: "@id",
          },
        },
      },
    );
    resource.prototype.transform = transform;

    return resource;
  }
})(angular);
